/**
 * Channels Module Types
 * 
 * Re-exports all types from submodules
 */

// Enums - ChannelType and SyncStatus are real enums, others are type aliases
export { ChannelType, SyncStatus } from './enums';
export type {
  ChannelName,
  ChannelStatus,
  ChannelConnectionStatus,
  ConnectionStep,
  UnitMappingStatus,
  UnitStatus,
  BookingUnitType,
} from './enums';

// Channel entity types
export type {
  IAvailableAction,
  IApiChannel,
  IApiConnectedAccount,
  IChannelProperty,
  IImportStatus,
  ChannelConfig,
  ChannelConfigMap,
  IChannelCardProps,
  IConnectStepProps,
  ISuccessStepProps,
  IImportPropertiesStepProps,
  IImportProgressStepProps,
} from './channel.types';

// API types
export type {
  IApiResponse,
  IGetChannelsResponse,
  IGetChannelsResult,
  IApiListing,
  IGetListingsResult,
  IChannelUnitsForImportResult,
  IChannelUnitForImport,
  IImportListingsRequest,
  IImportListingResult,
  IImportListingsResponse,
  IConnectAirbnbResponse,
  ICheckBookingConnectionRequest,
  ICheckBookingConnectionResponse,
  IValidateBookingHotelIdsRequest,
  IHotelValidationResult,
  IValidateBookingHotelIdsResponse,
  IValidateBookingSingleUnitIdRequest,
  IValidateBookingSingleUnitIdResponse,
  IImportBookingSingleListingRequest,
  IImportBookingSingleListingResponse,
  IGathernRequestOTPRequest,
  IGathernSendOTPApiResponse,
  IGathernRequestOTPResponse,
  IGathernVerifyOTPRequest,
  IGathernVerifyOTPApiResponse,
  IGathernVerifyOTPResponse,
  IUpdateListingStatusRequest,
  IUpdateListingStatusResponse,
  IApiChannelUnit,
  IGetAirbnbUnitsResult,
  IGetBookingUnitsResult,
  IGetGathernUnitsResult,
  IConnectChannelRequest,
  IConnectChannelResponse,
  ChannelRate,
  ChannelSetting,
  ChannelSettingsResponse,
  UpdateChannelRateRequest,
  IDisconnectAccountRequest,
  IDisconnectAccountResponse,
} from './api.types';

// Units mapping types
export type {
  ILinkedUnit,
  IMsoolUnit,
  IUnitSelection,
  IFilterState,
  IMappingUnitRequestDto,
  IMapUnitsRequest,
  IMapUnitsResponse,
  IMapUnitsResult,
  IChannelMappingResult,
  IChannelMappingError,
  IUnmapUnitRequestDto,
  IUnmapUnitsRequest,
  IUnmapUnitsResponse,
  IGetMsoolUnitsResponse,
  UnitData,
  HeaderSectionProps,
  ChannelCardComponentProps,
  UnitRowComponentProps,
  FilterSectionProps,
} from './units-mapping.types';
